import { render, staticRenderFns } from "./mDropZone.vue?vue&type=template&id=9fb31d5c&scoped=true"
import script from "./mDropZone.vue?vue&type=script&lang=ts"
export * from "./mDropZone.vue?vue&type=script&lang=ts"
import style0 from "./mDropZone.vue?vue&type=style&index=0&id=9fb31d5c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fb31d5c",
  null
  
)

export default component.exports